import { render } from "./AppInfiniteScroll.vue?vue&type=template&id=0b37e3e6&scoped=true"
import script from "./AppInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./AppInfiniteScroll.vue?vue&type=script&lang=js"

import "./AppInfiniteScroll.vue?vue&type=style&index=0&id=0b37e3e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b37e3e6"

export default script